import { render, staticRenderFns } from "./DoanhThuNgoai.vue?vue&type=template&id=be3f4100&"
import script from "./DoanhThuNgoai.vue?vue&type=script&lang=js&"
export * from "./DoanhThuNgoai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports